import { LockOutlined, MailOutlined } from '@ant-design/icons'
import { Button } from 'antd'
import clsx from 'clsx'
import { FormikContext } from 'formik'
import { useTranslation } from 'react-i18next'
import { Link, useNavigate } from 'react-router-dom'
import { toast } from 'react-toastify'

import { getLoginInitialValues } from './helpers/get-login-initial-values'
import { LoginFormValues } from './login-form.interface'
import styles from './login.page.module.scss'
import { LoginValidationSchema } from './validators/login-validation-schema'
import { ApiResponseStatus } from '../../../common/api/constants/api-response.status'
import { useFormik } from '../../../common/hooks/formik'
import { PureInput } from '../../../common/ui/pure-input/pure-input'
import { RouteEnum } from '../../../constants/routes.enum'
import { useLogin } from '../../../entities/auth/hooks/auth.hooks'

export const LoginPage = () => {
  const { t } = useTranslation()
  const navigate = useNavigate()
  const { mutateAsync: login } = useLogin()

  const formik = useFormik<LoginFormValues>({
    initialValues: getLoginInitialValues(),
    validationSchema: LoginValidationSchema(),
    onSubmit: () => {},
  })

  const handleSubmit = async () => {
    const err = await formik.validateForm()
    if (!Object.values(err).length) {
      const loginResult = await login({
        login: formik.values.email ?? '',
        password: formik.values.password ?? '',
      })
      if (loginResult.status === ApiResponseStatus.Success) {
        toast.success(t('auth.login.success'))
        if (loginResult.user.isQuizPassed || loginResult.user.isStaff) {
          navigate('/')

          return
        }
        navigate(`/${RouteEnum.ONBOARDING}`)

        return
      }
      if (loginResult.status === ApiResponseStatus.Error && loginResult.code === 401) {
        toast.error(t('auth.login.error'))

        return
      }
      if (loginResult.status === ApiResponseStatus.Error) {
        toast.error(t('common.errors.server'))
      }
    }
  }

  return (
    <FormikContext.Provider value={formik as any}>
      <div className="d-flex justify-content-center align-items-center h-100">
        <div className={clsx(styles.login, 'd-flex flex-column align-items-center bg-white p-5 px-4 px-sm-5  rounded-4')}>
          <div className="h2 mb-3 text-center">{t('auth.login.welcome')}</div>
          <div className="h6 mb-5 text-center">{t('auth.login.getStarted')}</div>

          {/*<div className="d-flex align-items-center justify-content-center">*/}
          {/*  <span>{t('auth.login.loginWith')}</span>*/}
          {/*  <div className="mx-3 py-2 px-2 bg-white cursor-pointer border rounded">*/}
          {/*    <img*/}
          {/*      alt="google-icon"*/}
          {/*      className="me-2"*/}
          {/*      src={GoogleIcon}*/}
          {/*    />*/}
          {/*    Google*/}
          {/*  </div>*/}
          {/*</div>*/}

          <PureInput
            {...formik.getFieldProps('email')}
            colClass="col-12"
            error={formik.errors.email}
            icon={<MailOutlined />}
            label={t('auth.login.email')}
            moduleStyle="mb-3"
          />
          <PureInput
            {...formik.getFieldProps('password')}
            colClass="col-12"
            error={formik.errors.password}
            icon={<LockOutlined />}
            label={t('auth.login.password')}
            moduleStyle="mb-3"
            type="password"
          />

          <Button
            className="mb-5 mt-3"
            onClick={handleSubmit}
            type="primary"
            block
          >
            {t('auth.login.logInButton')}
          </Button>

          <div className="w-100 d-flex flex-wrap justify-content-center justify-content-sm-between align-items-center">
            <p className="m-0 px-2 text-center">
              {t('auth.login.noAccount')} <Link to={RouteEnum.REGISTER}>{t('auth.login.signUp')}</Link>
            </p>
            <a
              className="text-black align-item-center"
              href="#"
            >
              {t('auth.login.forgotPassword')}
            </a>
          </div>
        </div>
      </div>
    </FormikContext.Provider>
  )
}
